const Emoji_C = {
    ':canadian': { id: 143, width: 23, height: 22 },
    ':cantstandit': { id: 605, width: 52, height: 18 },
    ':captain': { id: 144, width: 20, height: 25 },
    ':cat': { id: 62, width: 18, height: 18 },
    ':censored': { id: 146, width: 34, height: 18 },
    ':censored2': { id: 145, width: 48, height: 18 },
    ':chef': { id: 147, width: 23, height: 28 },
    ':chefsp': { id: 148, width: 21, height: 29 },
    ':chih': { id: 149, width: 15, height: 15 },
    ':chinese': { id: 150, width: 26, height: 20 },
    ':chipmunk': { id: 41, width: 18, height: 18 },
    ':chris': { id: 151, width: 20, height: 18 },
    ':cig': { id: 53, width: 18, height: 18 },
    ':cigarette': { id: 612, width: 18, height: 18 },
    ':clap_1': { id: 152, width: 31, height: 25 },
    ':closedeyes': { id: 154, width: 20, height: 20 },
    ':closedeyes2': { id: 153, width: 20, height: 20 },
    ':cloud9': { id: 155, width: 25, height: 26 },
    ':clover': { id: 156, width: 19, height: 20 },
    ':clown': { id: 158, width: 20, height: 20 },
    ':clown2': { id: 157, width: 28, height: 18 },
    ':coffee': { id: 54, width: 18, height: 18 },
    ':coke': { id: 55, width: 18, height: 18 },
    ':cold': { id: 160, width: 26, height: 32 },
    ':cold2': { id: 159, width: 25, height: 32 },
    ':confused_1': { id: 161, width: 18, height: 25 },
    ':confused': { id: 162, width: 16, height: 21 },
    ':confuzzled': { id: 163, width: 20, height: 20 },
    ':console': { id: 164, width: 46, height: 20 },
    ':construction': { id: 165, width: 47, height: 23 },
    ':cool': { id: 169, width: 20, height: 20 },
    ':cool1': { id: 166, width: 18, height: 18 },
    ':cool2': { id: 167, width: 20, height: 20 },
    ':cool3': { id: 168, width: 18, height: 18 },
    ':coolsmoker': { id: 13, width: 18, height: 18 },
    ':cowboy': { id: 170, width: 27, height: 26 },
    ':cranky': { id: 171, width: 22, height: 22 },
    ':crash': { id: 172, width: 34, height: 28 },
    ':cray': { id: 173, width: 31, height: 22 },
    ':crazy': { id: 174, width: 20, height: 20 },
    ':cry_1': { id: 175, width: 40, height: 18 },
    ':cry': { id: 26, width: 18, height: 18 },
    ':cryin_smilie': { id: 177, width: 20, height: 20 },
    ':cryss': { id: 178, width: 24, height: 20 },
    ':cuckoo': { id: 29, width: 26, height: 18 },
    ':cupidarrow': { id: 179, width: 31, height: 19 },
    ':curlers': { id: 180, width: 26, height: 22 },
}

export default Emoji_C
